<template>
  <div v-if="isShowModal" class="info-modal">
    <button class="info-modal__close" type="button" @click="() => isShowModal = false">
      <img alt="" src="/shop/images/modal-close.svg">
    </button>
    <div class="info-modal__title">
      <img alt="" class="img" src="/shop/images/tick-circle.svg">
      <span>{{ in18['modal_title'] }}</span>
    </div>
    <div class="info-modal__text">
      {{ in18['modal_text_start'] }} {{ amountComparedProducts }} {{ in18['modal_text_end'] }}
      <a :href="text_link_route" class="link  link--blue  link--underline  fw-500">
        {{ in18['modal_text_link'] }}
      </a>.
    </div>
  </div>
</template>

<script>
export default {
  name:     "ModalCompare",
  props:    {
    in18:            Object,
    text_link_route: String,
  },
  computed: {
    isShowModal: {
      get: function get() {
        return this.$store.getters.isShowCompareModal;
      },
      set: function set(value) {
        this.$store.commit('SET_IS_SHOW_COMPARE_MODAL', value);
      }
    },
    amountComparedProducts() {
      return this.$store.state.comparedProducts.length || 0;
    },
  },
}
</script>